import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import About from "./pages/about";
import Contact from "./pages/contact";
import Work from "./pages/work";
import TargetCursor from "./components/TargetCursor";

function App() {
    return (
        <>
            <TargetCursor spinDuration={2} hideDefaultCursor parallaxOn hoverDuration={0.2} />
            <Router>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/work" element={<Work />} />
                </Routes>
            </Router>
        </>
    );
}

export default App;
